import { useDispatch } from "react-redux";
import { useDeleteProfileImageMutation } from "../../../Store/Builder/techsbook.api";
import { setLoader } from "../../../Store/Slice/techsbookSlice";
import showToast from "../../Hooks/toast";
import useGetAccountApi from "../Account/getAccountApi";

const useDeleteProfileImageApi = () => {
  const dispatch = useDispatch();
  const [deleteImage] = useDeleteProfileImageMutation();
  const getAccountApi = useGetAccountApi();
  const send = (imageUploader) => {
    dispatch(setLoader(true));

    deleteImage()
      .unwrap()
      .then((res) => {
        showToast(res?.message ?? "Success", "success");
        getAccountApi.get();
        imageUploader.setPreviewImage(null);
      })
      .catch((err) => {
        dispatch(setLoader(false));
        showToast(err?.data?.message ?? "Error", "error");
      });
  };

  return {
    send,
  };
};

export default useDeleteProfileImageApi;
